import { loadFacebookSdk } from './load-facebook-sdk';

export function getFacebookData() {
    return loadFacebookSdk().then((FB) => {
        return new Promise((resolve, reject) => {
            FB.login(({authResponse}) => {
                if (!authResponse) {
                    return reject();
                }
                Promise.all([
                    new Promise((resolve) => FB.api('/me', (data) => resolve(data))),
                    new Promise((resolve) => FB.api('/me/likes', (data) => resolve(data))),
                ]).then(([facebookData, facebookLikes]) => {
                    resolve({facebookData, facebookLikes});
                });
            }, {
                scope: [
                    'email',
                    'user_birthday',
                    'user_education_history',
                    'user_interests',
                    'user_work_history',
                    'user_likes',
                    'user_relationships',
                    'user_location',
                ].join(', ')
            });
        });
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/facebook-profile-import.js